import { useEffect, useRef } from 'react';
import {
  Chart,
  BarElement,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend,
  BarController,
  ChartConfiguration,
} from 'chart.js';
import { BarChartProps } from './bar-chart.props';

// Register required components
Chart.register(BarController, BarElement, LinearScale, CategoryScale, Title, Tooltip, Legend);

function BarChart({ data, options }: BarChartProps) {
  const chartRef = useRef<HTMLCanvasElement>(null);
  const chartInstance = useRef<Chart<'bar'> | null>(null);

  useEffect(() => {
    const chartCanvas = chartRef.current;
    if (chartCanvas) {
      if (chartInstance.current) {
        chartInstance.current.destroy();
      }

      const config: ChartConfiguration<'bar'> = {
        type: 'bar',
        data,
        options: {
          responsive: true,
          maintainAspectRatio: false,
          ...options, // Allow overriding default options
        },
      };
      chartInstance.current = new Chart(chartCanvas, config);
    }

    return () => {
      if (chartInstance.current) {
        chartInstance.current.destroy();
      }
    };
  }, [data, options]);

  return <canvas ref={chartRef} className="w-full h-full" />;
}

export default BarChart;
